<script lang="ts">
	import { direction, toggleDirection } from '$lib/stores/directionStore';
</script>

<!-- svelte-ignore a11y-click-events-have-key-events a11y-no-static-element-interactions -->
<div class="langDirectionToggle" on:click={toggleDirection}>
	{$direction}
</div>

<style>
	.langDirectionToggle {
		display: flex;
		position: fixed;
		z-index: var(--z-index-Direction-toggle);
		align-items: center;
		justify-content: center;
		block-size: 70px;
		inline-size: 70px;
		margin: 20px;
		border-radius: 50%;
		background-color: var(--RED);
		color: white;
		cursor: pointer;
		inset-block-end: 75px;
		inset-inline-start: 0;
	}
</style>
